import { CommandAdminApi } from 'corso-types';

type Store = CommandAdminApi.ResponseBody<'/store', 'get'>[number];
type EnabledFeature = Store['enabledFeatures'][number];

export const enabledFeatureLabel = {
  Registrations: 'Registrations',
  Returns: 'Returns',
  'Shipping Protection': 'Shipping Protection',
  Tracking: 'Tracking',
  Warranties: 'Warranties',
} satisfies Record<EnabledFeature, string>;
